import { Ticket } from '@/services/ticketsService';
import { WeighingTicketData } from '@/components/WeighingTicket';

/**
 * Convertit un objet Ticket en WeighingTicketData pour les composants
 */
export const convertTicketToWeighingTicketData = (ticket: Ticket): WeighingTicketData => {
  // Construire le nom complet du chauffeur
  const chauffeurComplet = ticket.chauffeur_info 
    ? `${ticket.chauffeur_info.nom} ${ticket.chauffeur_info.prenom}`.trim()
    : ticket.chauffeur_nom || '';

  // Construire le nom complet du transporteur
  const transporteurComplet = ticket.transporteur_info?.nom || ticket.transporteur_nom || '';

  // Construire le nom complet du convoyeur
  const convoyeurComplet = ticket.convoyeur_info?.nom || ticket.convoyeur_nom || '';


  return {
    id: ticket.id.toString(),
    code: getTicketReference(ticket),
    grossWeight: ticket.poids_brut || 0,
    tareWeight: ticket.poids_tare || 0,
    netWeight: ticket.poids_net || 0,
    vehicle: ticket.camion_immatriculation || '',
    driver: chauffeurComplet,
    product: ticket.produit_nom || '',
    site: 'Site principal',
    tenant: 'Tenant principal',
    grossAt: ticket.date_heure || new Date().toISOString(),
    tareAt: ticket.updated_at || ticket.date_heure || new Date().toISOString(),
    grossUser: 'Agent Première Pesée',
    tareUser: 'Agent Deuxième Pesée',
    analysisUser: 'Agent Analyse Qualité',
    observations: ticket.observations || '',
    weighingDate: ticket.date_heure ? new Date(ticket.date_heure).toLocaleDateString('fr-FR') : new Date().toLocaleDateString('fr-FR'),
    campaignYear: new Date().getFullYear().toString(),
    ticketNumber: getTicketReference(ticket),
    supplierIdentity: ticket.fournisseur_info?.nom || ticket.fournisseur_nom || 'NOM DE L\'ENTITE',
    clientCode: ticket.client_info?.nom || ticket.client_nom || 'XXXX-XXXX',
    exporterCode: ticket.exportateur_info?.nom || ticket.exportateur_nom || '01',
    productNature: ticket.produit_info?.type || '',
    productOrigin: ticket.provenance || '',
    bushLotNumber: ticket.numero_lot || '',
    trailerRegistration: '', // Pas disponible dans l'interface Ticket
    transferSheetNumber: 'N° FICHE', // Pas disponible dans l'interface Ticket
    transporterName: transporteurComplet,
    destination: ticket.destination || '',
    provenance: ticket.provenance || '',
    stickerNumber: 'N° STICKER', // Pas disponible dans l'interface Ticket
    firstWeighingWeight: ticket.poids_brut || undefined,
    firstWeighingDateTime: ticket.date_heure || undefined,
    secondWeighingWeight: ticket.poids_tare || undefined,
    secondWeighingDateTime: ticket.updated_at || ticket.date_heure || undefined,
    humidityRateKOR: 'VALEUR % KOR : Valeur KOR',
    qualityRefraction: 0,
    packagingType: 'SACS 50KG',
    humidityRefraction: undefined,
    bagWeight: 50,
    sacsCount: {
      nb_sacs_declares: ticket.nb_sacs_declares || 0,
      nb_sacs_sains: ticket.nb_sacs_sains || 0,
      nb_sacs_recond: ticket.nb_sacs_recond || 0,
      nb_sacs_humides: ticket.nb_sacs_humides || 0,
      nb_sacs_dechires: ticket.nb_sacs_dechires || 0,
      nb_sacs_rejetes: ticket.nb_sacs_rejetes || 0,
      nb_sacs_acceptes: ticket.nb_sacs_acceptes || 0
    },
    qualityAnalysis: undefined,
    weighingAgentSignature: 'Agent Peseur',
    clientSupplierSignature: 'Client / Fournisseur',
    // Ajouter les acteurs pour le modal d'email
    client_nom: ticket.client_info?.nom || ticket.client_nom || '',
    client_email: ticket.client_info?.email || ticket.client_email || '',
    fournisseur_nom: ticket.fournisseur_info?.nom || ticket.fournisseur_nom || '',
    fournisseur_email: ticket.fournisseur_info?.email || ticket.fournisseur_email || '',
    exportateur_nom: ticket.exportateur_info?.nom || ticket.exportateur_nom || '',
    exportateur_email: ticket.exportateur_info?.email || ticket.exportateur_email || '',
    chauffeur_nom: chauffeurComplet,
    chauffeur_email: ticket.chauffeur_info?.email || ticket.chauffeur_email || '',
    transporteur_nom: transporteurComplet,
    transporteur_email: ticket.transporteur_info?.email || ticket.transporteur_email || '',
    convoyeur_nom: convoyeurComplet,
    convoyeur_email: ticket.convoyeur_info?.email || ticket.convoyeur_email || ''
  } as any;
};

/**
 * Récupère la référence d'un ticket (gère les deux formats)
 */
export const getTicketReference = (ticket: Ticket): string => {
  return (ticket as any).référence || ticket.reference || `#${ticket.id}`;
};
